import { RECEIPT_STATUS, type ReceiptStatus, type SettlementListItem } from '@fdh/shared';

/** Inner shell so corner ribbons sit inside the frame and never paint over the outer border. */
export const listCornerStatusCardInnerShellClass =
  'relative overflow-hidden rounded-[11px] bg-white dark:bg-gray-900';
import type { EmployerMoneyGivenBadgeKind } from './employerMoneyGivenSettlement';

export const receiptStatusRibbonClass = (status: ReceiptStatus): string => {
  if (status === RECEIPT_STATUS.SAVE) {
    return 'bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/55 dark:text-amber-100 dark:border-amber-700';
  }
  if (status === RECEIPT_STATUS.SUBMITTED) {
    return 'bg-blue-100 text-blue-900 border-blue-300 dark:bg-blue-950/55 dark:text-blue-100 dark:border-blue-700';
  }
  return 'bg-green-100 text-green-900 border-green-300 dark:bg-green-950/50 dark:text-green-100 dark:border-green-700';
};

export const settlementListStatusRibbonClass = (
  status: SettlementListItem['status'],
  locked: boolean,
): string => {
  if (status === 'submitted') {
    return 'bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/60 dark:text-amber-200 dark:border-amber-700';
  }
  if (status === 'reviewed' || locked) {
    return 'bg-green-100 text-green-900 border-green-300 dark:bg-green-950/50 dark:text-green-100 dark:border-green-700';
  }
  if (status === 'withdrawn') {
    return 'bg-gray-100 text-gray-800 border-gray-300 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600';
  }
  if (status === 'rejected') {
    return 'bg-red-100 text-red-900 border-red-300 dark:bg-red-950/45 dark:text-red-100 dark:border-red-800';
  }
  if (status === 'unlocked') {
    return 'bg-blue-100 text-blue-900 border-blue-300 dark:bg-blue-950/55 dark:text-blue-100 dark:border-blue-700';
  }
  return 'bg-green-100 text-green-900 border-green-300 dark:bg-green-950/50 dark:text-green-100 dark:border-green-700';
};

export type TaskTemplateLifecycle = 'not_started' | 'effective' | 'expired';

export const taskTemplateLifecycleRibbonClass = (lifecycle: TaskTemplateLifecycle): string => {
  if (lifecycle === 'not_started') {
    return 'bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/60 dark:text-amber-200 dark:border-amber-700';
  }
  if (lifecycle === 'effective') {
    return 'bg-green-100 text-green-900 border-green-300 dark:bg-green-950/50 dark:text-green-100 dark:border-green-700';
  }
  return 'bg-gray-100 text-gray-800 border-gray-300 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600';
};

export const employerMoneyGivenBadgeRibbonClass = (badge: EmployerMoneyGivenBadgeKind): string => {
  if (badge === 'pending_review') {
    return 'bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/60 dark:text-amber-200 dark:border-amber-700';
  }
  if (badge === 'settled') {
    return 'bg-green-100 text-green-900 border-green-300 dark:bg-green-950/50 dark:text-green-100 dark:border-green-700';
  }
  return 'bg-gray-100 text-gray-800 border-gray-300 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600';
};
